import { slugs } from '@/constants'
import { angelStudios } from './angel-studios'

export const angelGuild = {
  ...angelStudios,
  slug: slugs.angelGuild,
  name: 'Angel Guild',
  logo: '/v1684517496/angel-app/guild/GuildLogo.png',
}
